import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ionic-ios-send",
  "use": "icon-ionic-ios-send-usage",
  "viewBox": "0 0 16.179 16.177",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.179 16.177\" id=\"icon-ionic-ios-send\"><defs></defs><path class=\"a\" d=\"M20.171,4.539,4.7,11.281a.355.355,0,0,0,.013.645L8.9,14.289a.675.675,0,0,0,.771-.076L17.921,7.1c.055-.046.185-.135.236-.084s-.029.181-.076.236l-7.138,8.039a.672.672,0,0,0-.067.8l2.735,4.386a.356.356,0,0,0,.64-.008l6.4-15.468A.355.355,0,0,0,20.171,4.539Z\" transform=\"translate(-4.503 -4.503)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol